import { IApplicationState } from '../../types/redux';

export function getRegionId(state: IApplicationState) {
  const { id } = state.region.currentRegion;

  return id;
}
